import { render, staticRenderFns } from "./CarroBoton.vue?vue&type=template&id=9fce724c"
import script from "./CarroBoton.vue?vue&type=script&lang=js"
export * from "./CarroBoton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports